import Vue from "vue"
import VueRouter from "vue-router"
import store from "../store"
import system from "./system"
import cashier from "./cashier"
import procure from "./procure"
import settlement from "./settlement"
import orderManage from "./orderManage"
import product from "./product"
import invenroty from "./invenroty"
import marketing from "./marketing"
import staff from "./staff"
import project from "./project"
import member from "./member"
import customerRelations from "./customerRelations"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    component: () => import("../views/Main"),
    meta: { title: "门店后台管理系统" },
    children: [
      ...system,
      ...cashier,
      ...procure,
      ...settlement,
      ...orderManage,
      ...product,
      ...invenroty,
      ...marketing,
      ...member,
      ...staff,
      ...project,
      ...customerRelations,
      {
        path: "/personals",
        name: "personals",
        component: () => import("../views/Personals"),
        meta: { title: "个人信息" },
      },
    ],
  },
  {
    path: "/login",
    name: "/login",
    component: () => import("../views/Login"),
    meta: { title: "门店后台管理系统-登录" },
  },
  {
    path: "/forgotPassword",
    name: "forgotPassword",
    meta: { title: "忘记密码" },
    component: () => import("../views/forgotPassword.vue"),
  },
  {
    path: "/404",
    name: "404",
    meta: { title: "服务器拒绝访问或页面不存在" },
    component: () => import("../views/404"),
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

const originaPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originaPush.call(this, location).catch(err => err)
}

router.beforeEach((to, form, next) => {
  const token = store.state.token
  if (to.path == "/register" || to.path == "/forgotPassword") {
    next()
  } else if (!token && to.path !== "/login") {
    store.dispatch("logout")
    next("/login")
  } else if (token && to.path == "/login") {
    store.dispatch("logout")
    localStorage.clear()
    next()
  } else {
    next()
  }
})

router.afterEach(to => {
  if (to.meta.title) document.title = to.meta.title
})

export default router
